/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteFilterInput = {|
  id?: ?string,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type deleteFilterMutationVariables = {|
  input: DeleteFilterInput
|};
export type deleteFilterMutationResponse = {|
  +deleteFilter: ?{|
    +deletedFilterId: ?string
  |}
|};
export type deleteFilterMutation = {|
  variables: deleteFilterMutationVariables,
  response: deleteFilterMutationResponse,
|};
*/


/*
mutation deleteFilterMutation(
  $input: DeleteFilterInput!
) {
  deleteFilter(input: $input) {
    deletedFilterId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteFilterInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteFilterPayload",
    "kind": "LinkedField",
    "name": "deleteFilter",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedFilterId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteFilterMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteFilterMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "deleteFilterMutation",
    "operationKind": "mutation",
    "text": "mutation deleteFilterMutation(\n  $input: DeleteFilterInput!\n) {\n  deleteFilter(input: $input) {\n    deletedFilterId\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '861c60cf3ad16435e7fcdf91e29e85e8';

module.exports = node;
